import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild, ViewEncapsulation, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { Subject } from 'rxjs';
import { CfFtDialogService } from '../cf-feedback-template-dialog/cf-ft-dialog.service';
import { QnSbnDataService } from '../../../services/qn-sbn-data-service.service';
import { MatDialog } from '@angular/material/dialog';
import { CfFeedbackTemplateDropdownComponent } from '../cf-feedback-template-dropdown/cf-feedback-template-dropdown.component';
import { CfFeedbackTemplateRadioComponent } from '../cf-feedback-template-radio/cf-feedback-template-radio.component';

@Component({
  selector: 'dl-cf-feedback-template',
  templateUrl: './cf-feedback-template.component.html',
  styleUrls: ['./cf-feedback-template.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CfFeedbackTemplateComponent implements OnInit {
  // public isNewTemplateAdded = false;
  public formDisabled = false;
  public selectTypeList = [
    {
      label: 'Checkbox',
      value: '1',
      disabled: false
    },
    {
      label: 'Question',
      value: '2',
      disabled: false
    },
    {
      label: 'Dropdown',
      value: '3',
      disabled: false
    },
    {
      label: 'Radio',
      value: '4',
      disabled: false
    },
    {
      label: 'Attachment',
      value: '5',
      disabled: false
    }
  ];
  public selectPlaceholder = 'Select type...';
  public selectWidth = '150px';

  public selectMandatoryList = [
    // {
    //   label: 'Mandatory/Optional...',
    //   value: '0',
    //   disabled: false
    // },
    {
      label: 'Mandatory',
      value: '1',
      disabled: false
    },
    {
      label: 'Optional',
      value: '2',
      disabled: false
    }
  ];
  public selectMandatoryPlaceholder = 'Mandory/Optional';
  public selectMandatoryWidth = '186px';
  // @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Input() public isNewFromTemplate: boolean;
  // below addrow, dispcol, tableData from parent cf-feed.comp
  @Input() public addRowData: Subject<any>; // got passed on by parent var updateFeedbackOptions
  @Input() public displayedColumns = []; // for template it will include "select" column header and for new no need "select"
  @Input() public tableData = []; // for new single row and for template dynamic no of row will be pass
  @Output() public isFeedbackOptionAdded = new EventEmitter<{ isOptAdded: boolean }>();
  @Output() public isFoRowSelected = new EventEmitter<{ foSelected: any[] }>();
  @Output() public feedbackAddedChange = new EventEmitter<boolean>();

  public dataSource = new MatTableDataSource<any>(this.tableData);
  public selection = new SelectionModel<any>(true, []);
  public selectedRow;
  public selectTypeFormControl = new FormControl({ disabled: this.formDisabled });
  public selectMandatoryFC = new FormControl({ disabled: this.formDisabled });
  public selectTextFormControl = new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(500)]);
  ischeckforTemplate: boolean;
  public optArr: Array<string> = [];
  public optCount: number = 0;
  public optArrRadio: Array<string> = [];
  public optCountRadio: number = 0;
  public isFeedbackAdded: boolean = false;
  public constructor(
    private _QnSbnDataService:QnSbnDataService,
    private cfFtDialogService: CfFtDialogService,
    private dialog: MatDialog,
    private changeDetectionRef: ChangeDetectorRef,
    private readonly oneSnackBar?: OneSnackBarService
  ) {}

  public ngOnInit(): void {
    this.selectTypeFormControl.setValue(this.selectTypeList[0]);
    this.selectMandatoryFC.setValue(this.selectMandatoryList[0]);
    // if(this.addRowData) {
    this.addRowData.subscribe(data => {
      this.dataSource.data = data.placement === 'before' ? [...data.templateData, ...this.dataSource.data] : [...this.dataSource.data, ...data.templateData];
    });
    this.dataSource.data = this.tableData;
    // }
    this._QnSbnDataService.mappingData$.subscribe(observer=>{  
      this.ischeckforTemplate = !observer['template'];
     if(!this._QnSbnDataService.isEmpty(observer['configureFeedback'])){
        this.tableData = observer['configureFeedback'];
        this.dataSource.data = this.tableData;     
      }
      // this.dataTobestore = observer;
    })
    this.selectTextFormControl.statusChanges.subscribe(status => {
    if (status === 'INVALID') {
      this._QnSbnDataService.isValidFeedback$.next(false);
    } else if (status === 'VALID') {
      this._QnSbnDataService.isValidFeedback$.next(true);
    }
    });
  }

  public drop(event: CdkDragDrop<string[]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
    this.dataSource.data = JSON.parse(JSON.stringify(this.dataSource.data));
    this.tableData = JSON.parse(JSON.stringify(this.dataSource.data));
    this.addProduct(this.dataSource.data);
  }

  public addNewFeedbackOption(elm: any, rowIndex: number, fbType: any, fbText: string, fbMandatory: any): void {
    this.dataSource.data[rowIndex].iconSets = this.isNewFromTemplate ? 'delete-icon' : 'more-icon';
    this.dataSource.data[rowIndex].selectType = fbType.label;
    this.dataSource.data[rowIndex].selectText = fbText;
    this.dataSource.data[rowIndex].selectMandatory = fbMandatory.label;
    if(fbType.label !== "Dropdown") {
      delete this.dataSource.data[rowIndex].dropDownOpt;
    }
    if(fbType.label !== "Radio") {
      delete this.dataSource.data[rowIndex].radioOpt;
    }
    this.isFeedbackOptionAdded.emit({ isOptAdded: true });
    // this.selectTypeFormControl.reset();
    this.selectTypeFormControl.setValue(this.selectTypeList[0]);
    this.selectMandatoryFC.setValue(this.selectMandatoryList[0]);
    this.selectTextFormControl.reset();
    this.oneSnackBar.open('Feedback option successfully added', OneSnackBarType.SUCCESS);
 
    if(this.dataSource.data.length > 0){
      this.isFeedbackAdded = true;
      this._QnSbnDataService.isFeedbackAdded$.next(this.isFeedbackAdded);
      this.feedbackAddedChange.emit(this.isFeedbackAdded);
    } else {
      this.isFeedbackAdded = false;
      this._QnSbnDataService.isFeedbackAdded$.next(this.isFeedbackAdded);
      this.feedbackAddedChange.emit(this.isFeedbackAdded);
    }
    this.addProduct(this.dataSource.data);
  }

  public addFeedbackToTemplate(elm: any, index: number): void {
    // TODO: need to integrate backend services to add in template
    this.oneSnackBar.open('Feedback option successfully added to your templates.', OneSnackBarType.SUCCESS);
  }

  public deleteFeedbackFromTemplate(elm: any, index: number): void {
    // TODO: need to integrate backend services to delete from template
    this.dataSource.data = this.dataSource.data.filter(item => item !== elm);
    this.addProduct(this.dataSource.data);
    this.oneSnackBar.open('Feedback option successfully deleted', OneSnackBarType.SUCCESS);
  }

  public EditFeedbackFromTemplate(elm: any, index: number): void {
    this._QnSbnDataService.isEdited$.next(true);
    let prevFeedbackType = this.selectTypeList.filter(item => item.label == this.dataSource.data[index].selectType);
    let prevFeedbackValue = this.dataSource.data[index].selectText;
    let prevFeedbackMandatory = this.selectMandatoryList.filter(item => item.label == this.dataSource.data[index].selectMandatory);
    this.dataSource.data[index].iconSets = 'yes-icon';
    this.dataSource.data[index].selectType = '';
    this.dataSource.data[index].selectText = '';
    this.dataSource.data[index].selectMandatory = '';
    this.selectTypeFormControl.setValue(prevFeedbackType[0]);
    this.selectTextFormControl.setValue(prevFeedbackValue);
    this.selectMandatoryFC.setValue(prevFeedbackMandatory[0]);
  }

  public updateSelectRowStatus(): void {
    // this.cfFtDialogService.getSelectedRowInTemplate(this.selection.selected);
    this.isFoRowSelected.emit({ foSelected: this.selection.selected });
  }
  public addProduct(newData) {    
    this._QnSbnDataService.getMappedQnsbnData(newData,"ConfigureFeedBack");
 }

 public dropDownFn(index, element){
  const dialogRef = this.dialog.open(CfFeedbackTemplateDropdownComponent,{
    disableClose: true,
    autoFocus: true,
    data: element.dropDownOpt,
    panelClass: 'dropDownPopup'
  });
  dialogRef.afterClosed().subscribe(result => {
    if(result.status == 'confirm'){
      this.dataSource.data[index].dropDownOpt = result.optArr;
      this.changeDetectionRef.detectChanges();
    }
    if (result.status == 'cancel') {
      this.dataSource.data[index].dropDownOpt = [];
      this.changeDetectionRef.detectChanges();
    }
  });
 }

 public radioFn(index, element){
  const dialogRef = this.dialog.open(CfFeedbackTemplateRadioComponent,{
    disableClose: true,
    autoFocus: true,
    data: element.radioOpt,
    panelClass: 'radioPopup'
  });
  dialogRef.afterClosed().subscribe(result => {
    if(result.status == 'confirm'){
      this.dataSource.data[index].radioOpt = result.optArr;
      this.changeDetectionRef.detectChanges();
    }
    if (result.status == 'cancel') {
      this.dataSource.data[index].radioOpt = [];
      this.changeDetectionRef.detectChanges();
    }
  });
 }
}
